import React, { useEffect } from "react";
import { inject, observer } from "mobx-react"; // eslint-disable-line
import { Therm, Donors } from "../ui";
import { ErrorMessage, Spinner, Logo } from "../elements";

const FullOverlay = (props) => {

  useEffect(() => {
    /* Remove for production */
    const url = `${process.env.REACT_APP_LOCAL_URI}/max-top/`;
    /* Remove for production */

    let streamer = window.location.href.replace(url, "").split("/");
    if (streamer[0][0] === "@" || streamer[0][0] === "+") {
      streamer[2] = streamer[0][0];
      streamer[0] = streamer[0].substr(1, streamer[0].length);
    } else {
      streamer[2] = "@";
    }

    /* Remove for production */
    let streamType = streamer[2] ? streamer[2] : "@",
      username = streamer[0] ? streamer[0] : "warchant",
      slug = streamer[1]
        ? streamer[1]
        : "warchants-2019-playlive-campaign-to-end-childhood-cancer";
    /* Remove for production */
    props.overlayStore.socketConnect(streamType, username, slug);
    //props.userStore.getAccessToken();
  }, [])

  const { error, isLoading } = props.overlayStore;
  //const { accessToken } = props.userStore;

  return error ? (
    <ErrorMessage>THERE HAS BEEN AN ERROR.</ErrorMessage>
  ) : isLoading ? (
    <Spinner />
  ) : (
    <div className="max-overlay">

      <div className="max-overlay__left">
        <Logo />
      </div>

      <div className="max-overlay__right">
        <Donors />
        <Therm />
      </div>

    </div>
  );
}

export default inject("overlayStore")(observer(FullOverlay));
